export default "skymp5-front/023266e3c5350863611a441808d119df.gif";